/* Badeloft After Purchase Survey — file uploads + submit guard.
   Files go browser -> Shopify staged bucket -> Shopify Files via the Netlify broker;
   the contact-form submission carries only the resulting CDN URLs. */
(function () {
  'use strict';

  function initSurvey(root) {
    if (!root || root.dataset.bfSurveyReady === 'true') return;
    root.dataset.bfSurveyReady = 'true';

    var form = root.querySelector('form');
    if (!form) return; // success state
    var endpoint = root.dataset.uploadEndpoint;
    var tradeEndpoint = root.dataset.tradeEndpoint;
    var submitted = false;

    function fieldValue(name) {
      var field = form.elements.namedItem(name);
      return field ? String(field.value || '').trim() : '';
    }

    function setSubmitState(waiting) {
      var submit = form.querySelector('[type="submit"]');
      if (!submit) return;
      submit.disabled = waiting;
      if (waiting) {
        submit.setAttribute('aria-disabled', 'true');
        submit.classList.add('is-waiting');
      } else {
        submit.removeAttribute('aria-disabled');
        submit.classList.remove('is-waiting');
      }
    }

    function showNotice(message) {
      var notice = root.querySelector('[data-bf-survey-notice]');
      if (!notice) return;
      notice.textContent = message || '';
      notice.hidden = !message;
    }

    function initUploadField(field) {
      var input = field.querySelector('input[type="file"]');
      var hidden = field.querySelector('input[type="hidden"]');
      var status = field.querySelector('[data-bf-upload-status]');
      var nameEl = field.querySelector('[data-bf-upload-name]');
      if (!input || !hidden) return;

      function setStatus(kind, message) {
        field.dataset.uploadState = kind;
        if (status) { status.textContent = message || ''; status.hidden = !message; }
      }

      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        hidden.value = '';
        if (nameEl) nameEl.textContent = file ? file.name : '';
        if (!file) { setStatus('', ''); return; }
        if (file.size > 10 * 1024 * 1024) {
          input.value = '';
          if (nameEl) nameEl.textContent = '';
          setStatus('error', field.dataset.msgTooBig);
          return;
        }
        setStatus('busy', field.dataset.msgUploading);
        field.dataset.uploading = 'true';

        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ action: 'begin', filename: file.name, mimeType: file.type || 'application/octet-stream', size: file.size })
        })
          .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, d: d }; }); })
          .then(function (begin) {
            if (!begin.ok || !begin.d.target) throw new Error(begin.d.error || 'upload refused');
            var target = begin.d.target;
            var fd = new FormData();
            target.parameters.forEach(function (p) { fd.append(p.name, p.value); });
            fd.append('file', file);
            return fetch(target.url, { method: 'POST', body: fd }).then(function (up) {
              if (!up.ok) throw new Error('transfer failed');
              return fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'complete', resourceUrl: target.resourceUrl, storedFilename: begin.d.storedFilename, mimeType: file.type || 'application/octet-stream' })
              });
            });
          })
          .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, d: d }; }); })
          .then(function (done) {
            if (!done.ok) throw new Error(done.d.error || 'upload failed');
            hidden.value = done.d.url || ('Shopify file ' + done.d.id);
            setStatus('done', field.dataset.msgDone);
          })
          .catch(function (err) {
            input.value = '';
            if (nameEl) nameEl.textContent = '';
            setStatus('error', field.dataset.msgFailed + (err && err.message ? ' (' + err.message + ')' : ''));
          })
          .then(function () { delete field.dataset.uploading; });
      });
    }

    Array.prototype.slice.call(root.querySelectorAll('[data-bf-upload]')).forEach(initUploadField);

    // Colour selections -> one readable hidden value.
    var coloursHidden = form.querySelector('[data-bf-colours-value]');
    function syncColours() {
      if (!coloursHidden) return;
      coloursHidden.value = Array.prototype.slice.call(root.querySelectorAll('[data-bf-colour-input]'))
        .filter(function (c) { return c.checked; })
        .map(function (c) { return c.dataset.bfColourLabel; })
        .join(', ');
    }
    Array.prototype.slice.call(root.querySelectorAll('[data-bf-colour-input]')).forEach(function (c) {
      c.addEventListener('change', syncColours);
    });

    form.addEventListener('submit', function (event) {
      var busy = root.querySelector('[data-bf-upload][data-uploading="true"]');
      if (busy) {
        event.preventDefault();
        showNotice(root.dataset.msgWaitUploads);
        return;
      }
      if (submitted) { event.preventDefault(); return; }
      submitted = true;
      syncColours();
      setSubmitState(true);

      if (!tradeEndpoint) return;

      event.preventDefault();
      showNotice('');
      fetch(tradeEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          firstName: fieldValue('contact[First name]'),
          lastName: fieldValue('contact[Last name]'),
          company: fieldValue('contact[Company]'),
          email: fieldValue('contact[email]'),
          phone: fieldValue('contact[Phone]'),
          profession: fieldValue('contact[Profession]'),
          website: fieldValue('contact[Website]'),
          details: fieldValue('contact[Business and project details]'),
          document: fieldValue('contact[Document 1]'),
          companyFax: fieldValue('bf_company_fax')
        })
      })
        .then(function (response) {
          return response.json().then(function (data) { return { ok: response.ok, data: data }; });
        })
        .then(function (result) {
          if (!result.ok || !result.data.companyId) throw new Error(result.data.error || 'trade application failed');
          var record = document.createElement('input');
          record.type = 'hidden';
          record.name = 'contact[B2B company record]';
          record.value = result.data.companyId;
          form.appendChild(record);
          HTMLFormElement.prototype.submit.call(form);
        })
        .catch(function () {
          submitted = false;
          setSubmitState(false);
          showNotice(root.dataset.msgTradeFailed);
        });
    });
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-bf-survey]')).forEach(initSurvey);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
